import { css } from 'linaria';

export const card = css`
  display: flex;
  justify-content: space-between;
  height: 100%;
  gap: var(--space-200);
`;

export const link = css`
  cursor: pointer;
  padding: var(--space-150);
  background: var(--service-light);
  border-radius: var(--rounding-m);
  text-decoration: none;
`;

export const horizontalLink = css`
  display: block;
`;

export const horizontalContent = css`
  align-items: center;
`;

export const verticalContent = css`
  flex-direction: column;
`;
